import React from "react";
const ArrowToggle = React.forwardRef(({ children, onClick }: any, ref: any) => (
    <a
        href=""
        className="dropdown-menu-toggle nav-link"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <i className="las la-angle-down"></i>
    </a>
));

export default ArrowToggle;